export default __webpack_public_path__ + "static/media/charatermanager.744bef01.png";